import { useEffect, useState } from "react";
import emblem from "@/assets/sc_emblem_loading.png";

// Branded splash: logo pop-in -> breathing glow + staggered radar rings loop
// -> pop + fade-out once the app signals it's ready (see App.css for keyframes).
// When `ready` is omitted, it just loops forever with no exit (Suspense/route
// fallbacks unmount it externally the instant their content is available).
const MIN_VISIBLE_MS = 1030; // entrance (550ms) + hold (480ms) before we allow exit
const MAX_WAIT_MS = 6000; // safety cap — never block the app if `ready` somehow never arrives

export function LoadingScreen({ ready, onDone }) {
  const [minElapsed, setMinElapsed] = useState(ready === undefined);
  const [forceReady, setForceReady] = useState(false);
  const [exiting, setExiting] = useState(false);
  const effectiveReady = ready || forceReady;

  useEffect(() => {
    if (ready === undefined) return;
    const t = setTimeout(() => setMinElapsed(true), MIN_VISIBLE_MS);
    return () => clearTimeout(t);
  }, [ready]);

  // Force-exit if `ready` never arrives — a splash must never be able to
  // permanently block the app from being clicked.
  useEffect(() => {
    if (ready === undefined || ready) return;
    const t = setTimeout(() => setForceReady(true), MAX_WAIT_MS);
    return () => clearTimeout(t);
  }, [ready]);

  useEffect(() => {
    if (effectiveReady && minElapsed && !exiting) {
      setExiting(true);
      const t = setTimeout(() => onDone?.(), 420);
      return () => clearTimeout(t);
    }
  }, [effectiveReady, minElapsed, exiting, onDone]);

  return (
    <div className={`sc-loading-screen ${exiting ? "sc-loading-exit" : ""}`} data-testid="loading-screen">
      <div className="sc-loading-glow" />
      <div className="sc-loading-ring sc-loading-ring-1" />
      <div className="sc-loading-ring sc-loading-ring-2" />
      <div className={`sc-loading-logo-wrap ${exiting ? "sc-loading-pop" : ""}`}>
        <img src={emblem} alt="Screening Circle" className="sc-loading-logo" />
        <span className="sc-loading-shimmer" />
      </div>
    </div>
  );
}
